import React from 'react'
import VipIcon from '../../../form/component/VipIcon'
import Table from '../../../form/component/Table'
import { renderProcessName, renderTaskName } from '../../util/names'
import { renderStoreName } from '../../../store/util/renderStoreName'
import { renderCountryName } from '../../../customer/util/names'

export default partnerList => {
    const partnersById = partnerList.reduce((partnersById, partner) => {
        partnersById[partner.id] = partner.displayName
        return partnersById
    }, {})
    return [
        {
            property: 'vip',
            header: 'VIP',
            width: '45',
            renderer: processInstance => {
                return (
                    <VipIcon
                        active={
                            processInstance.vip === 1 ||
                            processInstance.vip === '1'
                        }
                    />
                )
            },
            columnName: 'process_task.vip',
        },
        {
            property: 'created',
            header: 'Created',
            comparator: Table.dateComparator('created'),
            renderer: Table.dateTimeRenderer('created'),
            columnName: 'process_task.created',
        },
        {
            property: 'due',
            header: 'Due',
            comparator: Table.dateComparator('due'),
            renderer: Table.dateTimeRenderer('due'),
            columnName: 'process_task.due',
        },
        {
            property: 'priority',
            header: 'Priority',
            columnName: 'process_task.priority',
        },
        {
            property: 'processName',
            header: 'process Name',
            renderer: processInstance => {
                return renderProcessName(processInstance.processName)
            },
            columnName: 'process_task.processName',
        },
        {
            property: 'name',
            header: 'taskname',
            renderer: processInstance => {
                return renderTaskName(processInstance.name)
            },
            columnName: 'process_task.name',
        },
        {
            property: 'role',
            header: 'Role',
            renderer: processInstance => {
                if (!processInstance.role) {
                    return ''
                }
                const list = JSON.parse(processInstance.role)
                return list.join(',')
            },
            columnName: 'process_task.role',
        },
        {
            property: 'processDisplayName',
            header: 'Name',
            columnName: 'process_task.processDisplayName',
        },

        {
            property: 'partnerId',
            header: 'Partner',
            columnName: 'process_task.partnerId',
            renderer: task => {
                if (!task.partnerId) {
                    return ''
                }
                return partnersById[task.partnerId]
            },
        },

        {
            property: 'assignedToName',
            header: 'Assigned',
            columnName: 'assignedToName',
        },
        {
            property: 'store',
            header: 'Store',
            renderer: processInstance => {
                return renderStoreName(processInstance.store)
            },
            columnName: 'process_task.storeId',
        },
        {
            property: 'dealOwner',
            header: 'DealOwner',
            columnName: 'dealOwner',
        },
        {
            property: 'countryCode',
            header: 'Country',
            renderer: processInstance => {
                return renderCountryName(processInstance.countryCode)
            },
            columnName: 'store_store.countryCode',
        },
    ]
}



// WEBPACK FOOTER //
// ./src/modules/process/component/task-list/all-open-tasklist-column-list.js